<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <mat-select y42StopPropagation [formControl]="control" (closed)="closed.emit()" [placeholder]="placeholder">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="formFilterCtrl"
        [placeholderLabel]="placeholder"
        noEntriesFoundLabel="No Results"
      >
        <fa-icon class="fs-08 text-gray-700" ngxMatSelectSearchClear [icon]="['fal', 'times']"></fa-icon>
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of state.filteredItems; trackBy: trackByValue" [value]="id ? item[id] : item">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, control: control }"></ng-container>
    </mat-option>
  </mat-select>
</mat-form-field>
